import React from 'react'
import ReactResizeDetector from 'react-resize-detector'
import Layout from '../layout/Layout'
import ErrorBoundary from '../utils/ErrorBoundary'
import {getFromLS, saveToLS} from '../utils/LocalStorage'
import empty from './templates/empty'
import {demo} from './templates/demo'

const hash = window.location.hash
const appName =  hash.replace(/^.{2}/g, '')
const layout = getFromLS(appName + '-currentLayout') || demo()
const saved = getFromLS(appName + '-saved') || []
const templates = () => [empty, demo()]

export class ManyPads extends React.PureComponent {

  handleResize(width) {
    saveToLS(appName + '-templates', templates())
  }

  render() {
    return (
      <ErrorBoundary>
        <ReactResizeDetector
            handleWidth
            handleHeight
            onResize={width => this.handleResize(width)}
            render={({ width, height }) => (
              <Layout
                appName={appName}
                data={layout}
                store={this.props.store}
                templates={templates()}
                saved={saved}
              />
            )}
            />
      </ErrorBoundary>
    )
  }
}
